import { cn } from 'src/shared/utils/cn'

import { ReviewStar } from '../../assets/review-star'

export default function OtherInfoContainer({
  isCurrentUser,
  reviewsCount,
  averageRating,
  shortAddress,
  className,
}: {
  isCurrentUser: boolean
  reviewsCount: number
  averageRating: number
  shortAddress: string
  className?: string
}) {
  // Helper for bullet

  return (
    <div className={cn('flex items-center justify-center gap-0 pt-1 text-sm lg:text-[15px]', className)}>
      {/* Location */}
      {!shortAddress ? (
        isCurrentUser ? (
          <button className="font-semibold text-primary underline focus:outline-none">Add location</button>
        ) : (
          <span className="font-semibold text-primary">No location</span>
        )
      ) : (
        <span className="font-semibold text-primary">{shortAddress}</span>
      )}

      {/* <Bullet /> */}
      <span className="mx-[7px]">·</span>

      {/* Reviews */}
      {reviewsCount === 0 ? (
        isCurrentUser ? (
          <button className="flex items-center gap-2 font-semibold text-primary underline focus:outline-none">
            Add reviews
          </button>
        ) : (
          <span className="flex items-center gap-2 font-semibold text-primary">0 reviews</span>
        )
      ) : (
        <>
          <ReviewStar size={16} className="-mt-0.5 mr-1 inline-block" />
          <span className="font-semibold text-primary">{averageRating.toFixed(1)}</span>
          <span className="mx-[7px]">·</span>
          <span className="font-semibold text-primary">
            {reviewsCount} review{reviewsCount === 1 ? '' : 's'}
          </span>
        </>
      )}
    </div>
  )
}
